import "./MainPartStyles.css";

function MainPartv3(props){
    return(
        <>
            <div className={props.container_cName} id={props.section_id}>
                <h1 className={props.heading_cName}>{props.heading}</h1>
                <h2 className={props.subheading_cName}>{props.subheading}</h2>
                <p className={props.paragraph_cName1}>{props.paragraph1}</p>
                <img className={props.img_cName1} alt="Molecular Biology" src={props.MainPartImg1}/>
                <p className={props.paragraph_cName2}>{props.paragraph2}</p>
                <img className={props.img_cName2} alt="Molecular Biology" src={props.MainPartImg2}/>
                <p className={props.paragraph_cName3}>{props.paragraph3}</p>
                <img className={props.img_cName3} alt="Molecular Biology" src={props.MainPartImg3}/>
                <p className={props.paragraph_cName4}>{props.paragraph4}</p>
                <img className={props.img_cName4} alt="Molecular Biology" src={props.MainPartImg4}/>
                <p className={props.paragraph_cName5}>{props.paragraph5}</p>
                <img className={props.img_cName5} alt="Molecular Biology" src={props.MainPartImg5}/>
            </div> 
        </>
    )
}

export default MainPartv3